<template>
  <app-modal
      :button-text="buttonText"
      :heading-text="headingText"
      @close="$emit('close')">
    <template slot="form">
      <div class="form form__email">
        <div class="row">
          <div class="col-sm-12">
            <input type="password" name="password" :placeholder="$t('downloadPasswordModal.headingText')" :value="password" @input="updatePassword" @keyup.enter="submitPassword" @keyup.27="$emit('close')" class="form form__input">
            <error-popup :message="$store.state.errors.password" v-if="$store.state.errors.password"></error-popup>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <button @click="submitPassword" class="modal__button pull-right" :class="!$store.state.isHkom ? 'bg-primary' : 'bg-primary--green'">{{ $t('downloadPasswordModal.buttonText') }}</button>
        </div>
      </div>
    </template>
  </app-modal>
</template>

<script>
import AppModal from '../layout/AppModal'
import ErrorPopup from '../ui/ErrorPopup'

export default {
  name: 'URLEditModal',
  components: {
    AppModal,
    ErrorPopup,
  },
  data () {
    return {
      password: null,
    }
  },
  methods: {
    submitPassword() {
      this.$emit('submit-password', this.password)
    },
    close() {
      this.$emit('close')
    },
    updatePassword(e) {
      this.password = e.target.value
      this.$store.resetError("password")
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/download/DownloadPasswordModal.vue